import React from 'react'

const PathogenMain = () => {
  return (
    <div id='website-responsive' className=''>
    <div className='bg-img' style={{ backgroundImage:'url("pathogen-testing/RPP-Testing-Banner-v2.webp")', height:'100%', width:'100%'}}>
        <div className='toxicology-text-padding'>
            <div className='-max-width display-none-1150'>
                <text className='fs-ss-40 text-montserrat fw-700 lh-1-2 text-ss-primary' style={{ letterSpacing:'-1px'}}>
                RESPIRATORY PATHOGEN<br/>
                PANEL (RPP) TESTING<br/>
                IN CHICAGO, IL
                </text>
            </div>

            <div className='services3-max-width display-block-1150'>
                <text className='fs-ss-32-5 text-montserrat fw-600 lh-1 text-ss-primary ' style={{ letterSpacing:'-1px'}}>
                Respiratory Pathogen
                Panel (RPP) testing
                in Chicago, IL
                </text>
            </div>
        </div>
    </div>
</div>
  )
}

export default PathogenMain